import { create } from 'zustand';

interface GetTrapByTokenModalState {
  isOpen: boolean;
  token?: string;
  onGetTrapByTokenModalClose: () => void;
  onGetTrapByTokenModalOpen: () => void;
}

export const useGetTrapByTokenModalStore = create<GetTrapByTokenModalState>(set => ({
  isOpen: false,
  token: '',
  onGetTrapByTokenModalClose: () => set({ isOpen: false, token: '' }),
  onGetTrapByTokenModalOpen: () => set({ isOpen: true, token: '' }),
}));
